import React, { FC, SyntheticEvent, useState } from 'react';
import { Autocomplete as MuiAutocomplete, Box, TextField } from '@mui/material';

export type RecipientOption = {
  id: string;
  name: string;
  email: string;
};

interface AutocompleteProps {
  label: string;
  loading: boolean;
  options: RecipientOption[];
  value: RecipientOption | null;
  disabled?: boolean;
  onChange: (event: SyntheticEvent, value: RecipientOption | null) => void;
  onInputChange: (event: SyntheticEvent, value: string) => void;
}

const RecipientsAutocomplete: FC<AutocompleteProps> = ({
  label,
  disabled,
  loading,
  options,
  value,
  onChange,
  onInputChange,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const includeValueToOptions = (value: RecipientOption | null) => {
    if (value && !options.includes(value)) {
      return [...options, value];
    }
    return options;
  };

  return (
    <MuiAutocomplete
      disablePortal
      disabled={disabled}
      options={includeValueToOptions(value)}
      loading={loading}
      loadingText={'Loading...'}
      fullWidth
      value={isFocused ? null : value}
      getOptionLabel={option => option.name ?? option}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => <TextField {...params} label={label} />}
      renderOption={(props, option) => (
        <Box component='li' {...props}>
          {option.name} <br /> {option.email}
        </Box>
      )}
      onChange={onChange}
      onInputChange={(event, value) => {
        onInputChange(event, value);
      }}
      onFocus={() => {
        setIsFocused(true);
      }}
      onBlur={() => {
        setIsFocused(false);
      }}
    />
  );
};

export default RecipientsAutocomplete;
